import React, { useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { systemsMessages } from 'src/features/systems/utils/messages';
import { GeneralBlock, GeneralBlockBody, GeneralBlockHeader } from 'src/registry/components/blocks/GeneralBlock';
import { ICON_MAP } from 'src/utils/constants';

type ImageUploadProps = {
    onChange: (file: File | null) => void;
    imagePreview?: string;
};

export const ImageUpload = ({ onChange, imagePreview }: ImageUploadProps) => {
    const { formatMessage } = useIntl();
    const [previewUrl, setPreviewUrl] = React.useState<string | null>(null);

    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();

        const file = e.dataTransfer.files?.[0];
        if (!file) return;

        setPreviewUrl(URL.createObjectURL(file));
        onChange(file);
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setPreviewUrl(URL.createObjectURL(file));
        onChange(file);
    };

    const displayPreview = previewUrl ?? imagePreview;

    return (
        <div className="flex max-w-full flex-col gap-2 lg:flex-row lg:gap-4">
            <GeneralBlock
                className="flex h-36 max-w-full items-center justify-center"
                onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleDrop(e);
                }}
                onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
            >
                <GeneralBlockHeader>
                    <FontAwesomeIcon icon={ICON_MAP.UPLOAD} size="xl" />
                </GeneralBlockHeader>
                <GeneralBlockBody className="items-center justify-center">
                    <span className="text-center">
                        <span className="text-primary-700 cursor-pointer font-bold" onClick={handleClick}>
                            {formatMessage(systemsMessages.clickToUpload)}{' '}
                        </span>
                        <span>{formatMessage(systemsMessages.dragAndDrop)}</span>
                    </span>
                    <div className="max-w-64 truncate text-xs text-gray-600">{displayPreview}</div>

                    <input
                        type="file"
                        accept=".bmp"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                    />
                </GeneralBlockBody>
            </GeneralBlock>
        </div>
    );
};
